import { create } from 'zustand';

interface NoteData {
    subjective: string;
    assessment: string;
    created_at?: string;
    updated_at?: string;
}

interface AddNoteStore {
    isNoteModalOpen: boolean;
    selectedNoteData: NoteData | undefined;
    selectedPatientId: string | undefined;
    openNoteModal: (noteData?: NoteData, patientId?: string) => void;
    closeNoteModal: () => void;
}

const useAddNoteStore = create<AddNoteStore>((set) => ({
    isNoteModalOpen: false,
    selectedNoteData: undefined,
    selectedPatientId: undefined,
    openNoteModal: (noteData, patientId) => set({ 
        isNoteModalOpen: true, 
        selectedNoteData: noteData,
        selectedPatientId: patientId
    }),
    closeNoteModal: () => set({ 
        isNoteModalOpen: false, 
        selectedNoteData: undefined,
        selectedPatientId: undefined
    }),
}));

export default useAddNoteStore;